import apiBase from "../../api";
import { FETCH_MYWASH_PROMO_WASH } from "../../urls";

const RETRY_DELAYS_MS = [1500, 4000];
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// The logged-in user's own wash (name, color, logo/photo as data: URIs),
// already resolved and filtered server-side - see mywashPromoState.js for
// how MyWashPromoV2 uses this. Never throws. A 200 with no wash is final;
// a failed request (network, auth refresh still in flight right after
// login, 5xx) is retried twice before falling back to null, the neutral
// "Vaša perionica" version. (05.10: one owner got the neutral tile once
// right after logging in.)
class MywashPromoService {
  fetchMyWash = async () => {
    for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt += 1) {
      try {
        const response = await apiBase.get(FETCH_MYWASH_PROMO_WASH);
        if (response.status === 200) return response.data?.data?.wash ?? null;
      } catch {
        // retried below
      }
      if (attempt < RETRY_DELAYS_MS.length) await wait(RETRY_DELAYS_MS[attempt]);
    }
    return null;
  };
}

export default new MywashPromoService();
